import styled from 'styled-components';

import { breakPoints } from '~/src/constants/breakpoints';

export const Wrapper = styled.div`
    gap: 24px;

    @media (max-width: ${breakPoints.desktop}) {
        gap: 32px;
    }
`;
